const MyAccountView = (resolve) => {
  require.ensure(['@/components/account/MyAccount'], () => {
    resolve(require('@/components/account/MyAccount'));
  });
};

const SubscriptionInformationView = (resolve) => {
  require.ensure(['@/components/account/SubscriptionInformation'], () => {
    resolve(require('@/components/account/SubscriptionInformation'));
  });
};

const IntegrationsView = (resolve) => {
  require.ensure(['@/components/account/Integrations'], () => {
    resolve(require('@/components/account/Integrations'));
  });
};

export const Account = (MainNavbar, MainSidebarMenu) => ({
  path: 'my-profile',
  name: 'MyAccountView',
  components: {
    top: MainNavbar,
    sidebar: MainSidebarMenu,
    content: MyAccountView,
  },
  meta: {
    className: 'page-my-account',
    requiresAuth: true,
    resource: 'myAccount.PageTitle',
  },
  beforeEnter(to, from, next) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      page_type: 'my-profile',
      site_type: 'interview',
    });
    next();
  },
});

export const Integrations = (MainNavbar, MainSidebarMenu) => ({
  path: 'integrations',
  name: 'IntegrationsView',
  components: {
    top: MainNavbar,
    sidebar: MainSidebarMenu,
    content: IntegrationsView,
  },
  meta: {
    className: 'page-integrations',
    requiresAuth: true,
    resource: 'integrations.PageTitle',
  },
  beforeEnter(to, from, next) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      page_type: 'ats-integrations',
      site_type: 'interview',
    });
    next();
  },
});

export const SubscriptionInformation = (MainNavbar, MainSidebarMenu) => ({
  path: 'subscription-information',
  name: 'SubscriptionInformationView',
  components: {
    top: MainNavbar,
    sidebar: MainSidebarMenu,
    content: SubscriptionInformationView,
  },
  meta: {
    className: 'page-my-subscription',
    requiresAuth: true,
    resource: 'subscription.PageTitle',
  },
});
